import { Controller } from '@hotwired/stimulus';
import videojs from "!video.js";

export default class extends Controller {
  static targets = [ "player" ]

  connect() {
    var player = videojs(this.playerTarget);

    // Don't play otherwise it will play automatically after revisit
    // player.play();
  }

  disconnect() {
    var player = videojs(this.playerTarget);
    player.dispose();
  }
}
